module.exports = "<vb-content-page-view\r\n  [hideActions]=\"true\">\r\n\r\n  <h1 page-title>Standort zuweisen</h1>\r\n\r\n  <div page-content>\r\n\r\n    <vb-location-marriage-wizard></vb-location-marriage-wizard>\r\n\r\n  </div>\r\n\r\n</vb-content-page-view>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/store-management/asset-management/views/location-marriage-wizzard-view/location-marriage-wizzard-view.component.html
// module id = ./src/app/store-management/asset-management/views/location-marriage-wizzard-view/location-marriage-wizzard-view.component.html
// module chunks = main